import React from "react";
import { errorMessages } from "../../../defines";
import { Controller, FieldPath } from "../../../react-hook-form";
import { dateToYYYYMMDD, isValidYYYYMMDDDate } from "../../../utils/dates";
import { splitDateRange } from "./splitDateRange";
import { VeriDateRangeInput } from "./VeriDateRangeInput";
import { HookFormVeriDateRangeInputProps } from "./VeriDateRangeInput.types";

const validateDateRange = (dateRange: string) => {
  const { startDate, endDate } = splitDateRange(dateRange);

  return isValidYYYYMMDDDate(startDate) && isValidYYYYMMDDDate(endDate)
    ? undefined
    : errorMessages.enterAValidDate;
};

export const HookFormDateRangeInput = <T, K extends FieldPath<T>>({
  form,
  name,
  ...rest
}: HookFormVeriDateRangeInputProps<T, K>) => {
  return (
    <Controller
      rules={{
        required: rest.isRequired ? errorMessages.requiredField : undefined,
        validate: rest.isRequired
          ? (value) => validateDateRange(value as string)
          : undefined,
      }}
      control={form.control}
      render={({ field, fieldState }) => {
        const { startDate, endDate } = splitDateRange(field.value as string);

        return (
          <VeriDateRangeInput
            label={"Strategies Employed"}
            onChange={(values) =>
              field.onChange(
                `${values.startDate ? dateToYYYYMMDD(values.startDate) : ""},${
                  values.endDate ? dateToYYYYMMDD(values.endDate) : ""
                }`,
              )
            }
            startDate={startDate}
            endDate={endDate}
            error={fieldState.error?.message}
            ref={field.ref}
            showCancelButton
            {...rest}
          />
        );
      }}
      name={name}
    />
  );
};
